/**
 * Emit hosts for the `getting-started` analytics group — 6 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { type OnboardingV2Variant } from '@/app-shell/flags/growth-flags';
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@heidi/analytics/events';

export function trackGettingStartedCompleted() {
  trackLegacyEvent({
    name: SegmentObjectName.GettingStarted,
    props: {
      action: SegmentActionName.GettingStartedCompleted,
    },
  });
}

export function trackGettingStartedPanelClosed() {
  trackLegacyEvent({
    name: SegmentObjectName.GettingStarted,
    props: {
      action: SegmentActionName.GettingStartedPanelClosed,
    },
  });

  // V2 — onboarding_updated
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.OnboardingUpdated,
    props: {
      step: 'getting_started_panel_closed',
    },
  });
}

export function trackGettingStartedPanelNextStep(step: string) {
  trackLegacyEvent({
    name: SegmentObjectName.GettingStarted,
    props: {
      action: SegmentActionName.GettingStartedPanelNextStep,
      step: step,
    },
  });

  // V2 — onboarding_updated
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.OnboardingUpdated,
    props: {
      step: step,
    },
  });
}

export function trackGettingStartedPanelOpenReferralModal() {
  trackLegacyEvent({
    name: SegmentObjectName.GettingStarted,
    props: {
      action: SegmentActionName.GettingStartedPanelOpenReferralModal,
    },
  });

  // V2 — onboarding_updated
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.OnboardingUpdated,
    props: {
      step: 'getting_started_panel_open_referral_modal',
    },
  });
}

export function trackGettingStartedPanelOpened() {
  trackLegacyEvent({
    name: SegmentObjectName.GettingStarted,
    props: {
      action: SegmentActionName.GettingStartedPanelOpened,
    },
  });

  // V2 — onboarding_updated
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.OnboardingUpdated,
    props: {
      step: 'getting_started_panel_opened',
    },
  });
}

export function trackOnboardingCompleted(input?: {
  onboardingVariant?: OnboardingV2Variant;
}) {
  track({
    event_name: TrackingEventName.OnboardingCompleted,
    props: input?.onboardingVariant
      ? { onboarding_variant: input.onboardingVariant }
      : {},
  });
}
